import { Components, Theme } from '@mui/material'
import { ExtendedPaletteOptions } from './palettes'
import { BeeCrewGrey, BeeCrewYellow } from './colors'

export const getComponents = (palette: ExtendedPaletteOptions): Components<Omit<Theme, 'components'>> => ({
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: '8px',
        textTransform: 'none',
        gap: '8px',
        fontWeight: '500',
        minWidth: '60px !important',
        whiteSpace: 'nowrap',
        '&.MuiButton-sizeSmall': {
          height: '30px',
          padding: '12px 24px',
          fontSize: '13.33px',
          '& svg': {
            height: '18px',
            width: '18px',
          },
        },
        '&.MuiButton-sizeMedium': {
          height: '36px',
          padding: '12px 30px',
          fontSize: '14px',
          '& svg': {
            height: '20px',
            width: '20px',
          },
        },
        '&.MuiButton-sizeLarge': {
          height: '42px',
          padding: '12px 36px',
          fontSize: '16px',
          '& svg': {
            height: '22px',
            width: '22px',
          },
        },
        '&.MuiButton-textPrimary': {
          color: palette.primary.main,
          '&:hover': {
            color: palette.primary.mainHover,
            backgroundColor: `${BeeCrewYellow[400]}1A`,
          },
        },
        '&.MuiButton-textSecondary': {
          color: palette.secondary.dark,
          '&:hover': {
            color: palette.secondary.darkHover,
            backgroundColor: `${BeeCrewGrey[400]}1A`,
          },
        },
        '&.MuiButton-containedPrimary': {
          backgroundColor: palette.primary.light,
          color: palette.primary.lightContrastText,
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: palette.primary.lightHover,
          },
          '&:disabled': {
            backgroundColor: palette.disabled.main,
            color: palette.disabled.mainContrastText,
            boxShadow: 'none',
          },
        },
        '&.MuiButton-containedSecondary': {
          backgroundColor: palette.secondary.main,
          color: palette.secondary.mainContrastText,
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: palette.secondary.mainHover,
          },
          '&:disabled': {
            backgroundColor: palette.disabled.main,
            color: palette.disabled.mainContrastText,
            boxShadow: 'none',
          },
        },
        '&.selected': {
          backgroundColor: palette.primary.light,
          color: palette.primary.lightContrastText,
          '&:hover': {
            backgroundColor: palette.primary.lightHover,
          },
        },
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: {
        '&.MuiChip-colorPrimary': {
          backgroundColor: palette.primary.light,
          color: palette.primary.lightContrastText,
        },
      },
    },
  },
  MuiTableSortLabel: {
    // TODO: Do srpawdzenia
    styleOverrides: {
      root: {
        color: 'text.base',
      },
    },
  },
  MuiTextField: {
    styleOverrides: {
      root: {
        color: palette.text.base,
        '& .MuiOutlinedInput-root:not(.Mui-focused):not(.Mui-disabled)': {
          '&:hover fieldset': {
            borderColor: palette.text.mediumEmphasis,
          },
        },
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        color: palette.text.base,
      },
    },
  },
  MuiTableContainer: {
    styleOverrides: {
      root: {
        border: '1px solid',
        borderRadius: '8px',
        borderColor: palette.background.elevation9,
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        backgroundColor: 'inherit',
        paddingRight: '8px',
        color: 'inherit',
      },
    },
  },
})